import supabase from '../../supabase-client.js';

// Default admin data
const defaultAdmin = {
  email_admin: 'admin@lithay.com',
  name_admin: 'Administrator',
  password_admin: 'admin123'
};

// Function to seed admin user
export const seedAdmin = async () => {
  try {
    console.log('🔐 Checking admin user...');
    
    // Check if admin already exists
    const { data: existingAdmin, error: checkError } = await supabase
      .from('dataadmin')
      .select('id, email_admin')
      .eq('email_admin', defaultAdmin.email_admin)
      .single();

    if (checkError && checkError.code !== 'PGRST116') {
      console.error('Error checking admin:', checkError);
      return false;
    }

    if (existingAdmin) {
      console.log('✅ Admin user already exists');
      return true;
    }

    // Insert default admin
    const { data, error } = await supabase
      .from('dataadmin')
      .insert([defaultAdmin])
      .select('id, email_admin')
      .single();

    if (error) {
      console.error('❌ Error creating admin user:', error);
      return false;
    }

    console.log('✅ Admin user created successfully!');
    console.log(`👤 Admin ID: ${data.id}`);
    console.log(`📧 Email: ${data.email_admin}`);
    return true;
  } catch (error) {
    console.error('❌ Error in seedAdmin:', error);
    return false;
  }
};

// Function to update admin password
export const updateAdminPassword = async (newPassword) => {
  try {
    console.log('🔐 Updating admin password...');
    
    const { data, error } = await supabase
      .from('dataadmin')
      .update({ password_admin: newPassword })
      .eq('email_admin', defaultAdmin.email_admin)
      .select('id, email_admin')
      .single();

    if (error) {
      console.error('❌ Error updating admin password:', error);
      return false;
    }

    console.log('✅ Admin password updated successfully!');
    return true;
  } catch (error) {
    console.error('❌ Error updating admin password:', error);
    return false;
  }
};

// Function to check if admin exists
export const checkAdminExists = async () => {
  try {
    const { data, error } = await supabase
      .from('dataadmin')
      .select('id, email_admin')
      .eq('email_admin', defaultAdmin.email_admin)
      .single();

    if (error && error.code !== 'PGRST116') {
      console.error('Error checking admin:', error);
      return false;
    }

    return !!data;
  } catch (error) {
    console.error('Error checking admin exists:', error);
    return false;
  }
};

// Function to initialize admin if needed
export const initializeAdmin = async () => {
  try {
    const exists = await checkAdminExists();
    
    if (!exists) {
      console.log('📭 Admin user not found, creating default admin...');
      return await seedAdmin();
    } else {
      console.log('✅ Admin user already exists');
      return true;
    }
  } catch (error) {
    console.error('Error initializing admin:', error);
    return false;
  }
};

export default { seedAdmin, updateAdminPassword, checkAdminExists, initializeAdmin };

